import { SideNavMenuItem } from '@metrika/ui-kit/carbon';
import React from 'react';
import { Link, useRouteMatch } from 'react-router-dom';

const useExactRouteMatch = (path: string) => !!(useRouteMatch(path) || {})['isExact'];

export const CarbonNavSubLink: React.FC<{
   to: string;
   title?: string;
   onClick?: (event: React.MouseEvent<HTMLAnchorElement>) => void;
   isActive?: boolean;
   style?: React.CSSProperties;
}> = (props) => {
   const match = useExactRouteMatch(props.to);
   return (
      <SideNavMenuItem
         as={Link}
         to={props.to}
         isActive={match || props.isActive}
         onClick={props.onClick}
         style={props.style}
      >
         {props.title || props.children}
      </SideNavMenuItem>
   );
};
